enum SubscriptionStatus {
  REQUESTED = "requested",
  REVOKED = "revoked",
  ACTIVE = "active",
  EXPIRED = "expired"
}

export default SubscriptionStatus;
